/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryGetMcpServerActivity } from "../funcs/telemetryGetMcpServerActivity.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetMcpServerActivityResult } from "../models/components/getmcpserveractivityresult.js";
import {
  GetMcpServerActivityRequest,
  GetMcpServerActivitySecurity,
} from "../models/operations/getmcpserveractivity.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMcpServerActivityQueryData = GetMcpServerActivityResult;

export function prefetchGetMcpServerActivity(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMcpServerActivityRequest,
  security?: GetMcpServerActivitySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMcpServerActivityQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMcpServerActivityQuery(
  client$: GramCore,
  request: GetMcpServerActivityRequest,
  security?: GetMcpServerActivitySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetMcpServerActivityQueryData>;
} {
  return {
    queryKey: queryKeyGetMcpServerActivity({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function getMcpServerActivityQueryFn(
      ctx,
    ): Promise<GetMcpServerActivityQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryGetMcpServerActivity(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMcpServerActivity(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "telemetry", "getMcpServerActivity", parameters];
}
